import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EntityFieldDTO  {
    _originalTypeClassName = "zERP.BO.EntityFieldDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EntityFieldDTO.translate = translateService;
}
this.Id = null;
this.Name = null;
this.isPrimitive = false;
this.isCollection = false;
this.Value = null;
this.IsForeign = false;
this.DataType = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
isPrimitive:any;
isCollection:any;
Value:any;
IsForeign:any;
DataType:any;
Description:any;
EntityFieldDTOValue:any;
static setEntityFieldDTOValue = ($this, value) => {
var oldValue = $this.EntityFieldDTOValue;
$this.EntityFieldDTOValue = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}